import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getSystemRunTime, loadGpr } from 'pages/PageGpr/api';
import { IGpr } from 'pages/PageGpr/interfaces';

export const path = '/gpr/form/:gprId?';
export const getPath = (gprId?: number): string => (gprId ? `/gpr/form/${gprId}` : '/gpr/form');

// gprId нет — создание нового графика, gpr в состоянии формы соберётся из дефолтов.
const loadGprOrNull = (gprId?: string): Promise<IGpr | null> =>
  gprId ? loadGpr(Number(gprId)) : Promise.resolve(null);

const PageGprForm: React.FC = (props) => {
  const { gprId } = useParams<{ gprId?: string }>();

  // Справочники полей выбора здесь не грузим — каждое поле грузит свой при открытии списка, а
  // названия уже выбранных значений отдаёт сам график.
  const GprForm = Loadable.Map({
    loader: {
      page: () => import('./page'),
      gpr: () => loadGprOrNull(gprId),
      systemRunTime: getSystemRunTime,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  // key — чтобы при переходе между графиками (или к созданию нового) Loadable.Map перезагрузил
  // данные, а не переиспользовал состояние формы предыдущего графика.
  return <GprForm key={gprId || 'new'} {...props} />;
};

export default PageGprForm;
